import config from 'src/config';

const applicationType = 'transporter-portal';

export const MOBILE_BREAK_POINT = 590;
export const MIN_WIDTH = 1200;
export const NAVBAR_HEIGHT = 64;
const { API_BASE_URL, DEFAULT_ORG_PRETTY_NAME, ANALYTICS_FRONTEND_BASE_URL,
  IFRAME_NON_STRICT_MODE, WB_BASE_URL, FIREBASE_CONFIG,
  FIREBASE_VAPID_KEY, FIRESTORE_DB_ID, FINANCE_SERVICE_URL } = config;
export default {
  API_BASE_URL,
  applicationType,
  DEFAULT_ORG_PRETTY_NAME,
  ANALYTICS_FRONTEND_BASE_URL,
  IFRAME_NON_STRICT_MODE,
  FINANCE_SERVICE_URL,
  WB_BASE_URL,
  FIREBASE_CONFIG,
  FIREBASE_VAPID_KEY,
  FIRESTORE_DB_ID,
};
